import { createFrontendModule, NotFoundErrorPage } from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';
import { Box, Typography } from '@material-ui/core';
import { LinkButton } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { VARIA_SLACK_CHANNEL } from '../constants';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(6),
    marginLeft: theme.spacing(6),
  },
  content: {
    maxWidth: '600px',
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
  titleContainer: {
    marginBottom: theme.spacing(3),
  },
  title: {
    marginBottom: 0,
  },
}));

const CustomNotFoundErrorPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Box className={classes.content}>
        <div className={classes.titleContainer}>
          <Typography variant="subtitle1">Error 404: Page not found</Typography>

          <Typography variant="h1" className={classes.title}>
            Something went wrong.
          </Typography>
        </div>

        <Typography>
          We can't seem to find the page you're looking for. Please try again with a different URL
          or use one of the options below.
        </Typography>

        <div className={classes.buttonContainer}>
          <LinkButton variant="contained" color="primary" to="/search">
            Search
          </LinkButton>
          <LinkButton
            variant="outlined"
            color="primary"
            to="https://github.com/equinor/varia/issues"
            target="_blank"
            rel="noopener noreferrer"
          >
            Create an issue
          </LinkButton>
          <LinkButton
            variant="outlined"
            color="primary"
            to={VARIA_SLACK_CHANNEL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact support on Slack
          </LinkButton>
        </div>
      </Box>
    </div>
  );
};

const CustomErrorNotFoundPageBluePrint = SwappableComponentBlueprint.make({
  name: 'not-found-error-page',
  params: define =>
    define({
      component: NotFoundErrorPage,
      loader: () => CustomNotFoundErrorPage,
    }),
});

export const notFoundErrorPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [CustomErrorNotFoundPageBluePrint],
});
